import { InfoCircleOutlined } from '@ant-design/icons';
import styles from './Style.module.scss';

const Warning = ({
  title,
  warnings,
  asList = false,
  children,
  includeTitle = true,
}: {
  title: string;
  warnings: string[];
  asList?: boolean;
  children?: React.ReactNode;
  includeTitle?: boolean;
}) => {
  return (
    <div className={styles.ccpa_warning}>
      <InfoCircleOutlined
        style={{ marginLeft: '8px', color: '#836A00', marginTop: '3px' }}
      />
      <div>
        {title && <p className={styles.warning_title}>{title}:</p>}
        {asList ? (
          <ol>
            {warnings.map((warning, index) => (
              <li key={index}>{warning}</li>
            ))}
          </ol>
        ) : (
          <p>{warnings.join('')}</p>
        )}
        {children ? children : null}
      </div>
    </div>
  );
};

export default Warning;
